export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./chevron-right.vue?vue&type=template&id=7f0417ac&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/chevron-right.vue?vue&type=template&id=7f0417ac&
// module id = 1161
// module chunks = 0